import { useState } from "react";

import {
    LayoutDashboard,
    Image,
    CookingPot,
    Star,
    BarChart3,
    History,
} from "lucide-react";

import "./FoodTabs.css";

import OverviewTab from "./tabs/OverviewTab";
import GalleryTab from "./tabs/GalleryTab";
import IngredientsTab from "./tabs/IngredientsTab";
import ReviewsTab from "./tabs/ReviewsTab";
import AnalyticsTab from "./tabs/AnalyticsTab";
import ActivityTab from "./tabs/ActivityTab";

function FoodTabs({ food }) {

    const [activeTab, setActiveTab] = useState("overview");

    const tabs = [
        {
            id: "overview",
            label: "Overview",
            icon: <LayoutDashboard size={18} />,
        },
        {
            id: "gallery",
            label: "Gallery",
            icon: <Image size={18} />,
        },
        {
            id: "ingredients",
            label: "Ingredients",
            icon: <CookingPot size={18} />,
        },
        {
            id: "reviews",
            label: "Reviews",
            icon: <Star size={18} />,
        },
        {
            id: "analytics",
            label: "Analytics",
            icon: <BarChart3 size={18} />,
        },
        {
            id: "activity",
            label: "Activity",
            icon: <History size={18} />,
        },
    ];

    return (

        <div className="food-tabs-wrapper">

            <div className="food-tabs-header">

                {tabs.map((tab) => (

                    <button
                        key={tab.id}
                        className={
                            activeTab === tab.id
                                ? "tab-btn active"
                                : "tab-btn"
                        }
                        onClick={() => setActiveTab(tab.id)}
                    >
                        {tab.icon}
                        {tab.label}
                    </button>

                ))}

            </div>

            <div className="food-tab-content">

                {activeTab === "overview" && (
                    <OverviewTab food={food} />
                )}

                {activeTab === "gallery" && (
                    <GalleryTab food={food} />
                )}

                {activeTab === "ingredients" && (
                    <IngredientsTab food={food} />
                )}

                {activeTab === "reviews" && (
                    <ReviewsTab food={food} />
                )}

                {activeTab === "analytics" && (
                    <AnalyticsTab food={food} />
                )}

                {activeTab === "activity" && (
                    <ActivityTab food={food} />
                )}

            </div>

        </div>

    );

}

export default FoodTabs;